<template>
  <v-btn fab x-small :to="authRoute()">
    <v-icon>mdi-account-circle-outline</v-icon>
  </v-btn>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "XsLoginButton",
  computed: {
    ...mapGetters("auth", { authorized: "isAuthenticated" }),
  },
  methods: {
    authRoute() {
      const accountRoute = { name: "account" };
      const loginRoute = { name: "login" };

      return this.authorized ? accountRoute : loginRoute;
    },
  },
};
</script>
